import { connect } from 'react-redux'
import { fetchPostsWithRedux } from '../modules/headermenutest'

/*  This is a container component. Notice it does not contain any JSX,
    nor does it import React. This component is **only** responsible for
    wiring in the actions and state necessary to render a presentational
    component - in this case, the counter:   */

import HeaderMenuTest from '../components/_partial/HeaderMenuTest'

/*  Object of action creators (can also be function that returns object).
    Keys will be passed as props to presentational components. Here we are
    implementing our wrapper around increment; the component doesn't care   */

/*  State to Props  */
function mapHeaderMenuStateToProps (state) {
  return (state.posts)
}

const HeaderMenuListTest = connect(mapHeaderMenuStateToProps, { fetchPostsWithRedux })(HeaderMenuTest)
export default HeaderMenuListTest



// WEBPACK FOOTER //
// ./src/containers/HeaderMenuTestContainer.js